<template functional>
  <div>
    <div v-for="item in props.row.sigatoka_config_ages" :key="item.id">
      <div v-if="item.age === 0">
        <translate-text keyTranslate="sigatoka.expecting" />
      </div>
      <div v-else-if="item.age === 1">
        <translate-text keyTranslate="sigatoka.newly_given_birth" />
      </div>
      <div v-else>
        {{ item.age }}
        <translate-text keyTranslate="common_words.weeks" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ConfigInfo',
};
</script>
